import Markdown from "react-native-markdown-display";
import { Link } from "expo-router";
import { Button, Layout, Logo } from "@ptsd/uikit";
import { ArrowLeft } from "@tamagui/lucide-icons";
import { Image, Separator, Text, useMedia, View, XStack } from "tamagui";

import { Footer } from "../layout/footer";
import { Header } from "../layout/header";

//eslint-disable-next-line @typescript-eslint/no-var-requires
const img = require("../../assets/onboarding/frame-1.png");

export const GlobalErrorScreen: React.FC<{
  error?: string;
}> = ({ error }) => {
  const { sm } = useMedia();

  const errorText =
    error === "FORBIDDEN"
      ? "Ваш доступ до кабінету призупинено менеджером"
      : error;

  return (
    <Layout variant="dualbackground">
      {sm && <Header />}
      <View
        $sm={{
          flex: 1,
        }}
        flex={2}
        flexDirection="row"
        width={"100%"}
      >
        <View
          gap={"$15"}
          paddingHorizontal={"$2.5"}
          paddingTop={"$4"}
          flex={1}
          alignItems="flex-end"
          width={"50%"}
          $gtSm={{
            paddingRight: 110,
          }}
          $sm={{
            alignItems: "center",
          }}
        >
          {!sm && (
            <View width={"100%"} paddingTop={"$5.8"} maxWidth={413}>
              <Logo
                style={{
                  width: 214,
                  height: 36,
                }}
              />
            </View>
          )}

          <View width={"100%"} gap={"$3"} maxWidth={413}>
            <View width={"100%"} gap={"$2"}>
              <Text
                fontFamily={"$subtitle"}
                fontWeight={"$6"}
                fontSize={"$7"}
                lineHeight={"$7"}
              >
                Щось пішло не так 🤕
              </Text>

              <Markdown
                style={{
                  body: {
                    fontFamily: "Fixel Text",
                    fontSize: 18,
                    lineHeight: 22,
                  },
                }}
              >
                {errorText
                  ? errorText
                  : `Ми вже знайшли помилку і виправляємо її. Трохи терпіння — і можна буде продовжити.\n\n Спробуйте **оновити сторінку** або **повернутись на крок назад.**`}
              </Markdown>
            </View>
            <Separator borderColor={"$gray-200"} />
            <XStack gap={"$1"}>
              <Link href={"/"} asChild>
                <Button variant="gray" rounded="lg" size="lg" mode="icon">
                  <ArrowLeft />
                </Button>
              </Link>

              <Button
                variant="primary"
                width={"100%"}
                size="lg"
                rounded="lg"
                flex={1}
                maxWidth={350}
                onPress={() => {
                  if (window) {
                    window.location.reload();
                  }
                }}
              >
                Оновити сторінку
              </Button>
            </XStack>
          </View>
        </View>
        {!sm && (
          <View
            paddingHorizontal={"$2.5"}
            width={"50%"}
            alignItems="flex-start"
            paddingLeft={110}
            justifyContent="center"
            flex={1}
          >
            <Image
              maxHeight={560}
              src={img}
              contain="size"
              width="100%"
              resizeMode="contain"
              aspectRatio={1}
            />
          </View>
        )}
      </View>
      {sm && <Footer />}
    </Layout>
  );
};
